import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import { ComponentSync } from '@nu-art/thunderstorm-frontend/index';
import { _keys, filterDuplicates, RuntimeModules } from '@nu-art/ts-common';
import { graphviz } from 'd3-graphviz';
import { Digraph, Edge, Node, Subgraph, toDot } from 'ts-graphviz';
export class Component_DependencyViewer extends ComponentSync {
    graphContainerRef = React.createRef();
    componentDidMount() {
        if (!this.graphContainerRef.current) {
            this.logWarning('Finished mounting but no ref to container');
            return;
        }
        this.renderGraph();
        this.forceUpdate();
    }
    deriveStateFromProps(nextProps, state) {
        state = super.deriveStateFromProps(nextProps, state);
        state.protoModules = RuntimeModules().filter((module) => !!module.dbDef?.dbKey);
        return state;
    }
    getMidNode = (startNode, endNode, property) => {
        const id = `${startNode.id} => ${endNode.id} \n\nDependency property: ${property}`;
        return new Node(id, {
            id: id,
            shape: 'circle',
            width: 0.2,
            label: '',
            style: 'filled',
            fillcolor: '#ffffff',
            tooltip: id
        });
    };
    getModuleNode = (module) => {
        const id = module.dbDef.dbKey;
        return new Node(id, {
            id: id,
            shape: 'rect',
            style: 'filled',
            label: module.dbDef.entityName,
            fillcolor: '#ffffff',
            fontsize: 13,
            fontcolor: '#333333',
            width: 3
        });
    };
    getDependencyNode = (startNode, endNode, midNode) => {
        const id = `${startNode.id} => ${endNode.id}`;
        return [new Edge([startNode, midNode], { id: id, arrowhead: 'none' }), new Edge([midNode, endNode], { id: id })];
    };
    getGraphString = () => {
        const graph = new Digraph('', { bgcolor: 'transparent' });
        const subgraph = new Subgraph('Container');
        graph.addSubgraph(subgraph);
        const moduleNodes = {};
        this.state.protoModules.forEach(module => {
            const moduleNode = this.getModuleNode(module);
            moduleNodes[module.dbDef.dbKey] = moduleNode;
            subgraph.addNode(moduleNode);
        });
        this.state.protoModules.forEach(module => {
            const startNode = moduleNodes[module.dbDef.dbKey];
            if (module.dbDef.dependencies)
                filterDuplicates(_keys(module.dbDef.dependencies), item => module.dbDef.dependencies[item].dbKey).map(key => {
                    const endNode = moduleNodes[module.dbDef.dependencies[key].dbKey];
                    const midNode = this.getMidNode(startNode, endNode, key);
                    const edge = this.getDependencyNode(startNode, endNode, midNode);
                    subgraph.addNode(midNode);
                    subgraph.addEdge(edge[0]);
                    subgraph.addEdge(edge[1]);
                });
        });
        return toDot(graph);
    };
    renderGraph = () => {
        const graphString = this.getGraphString();
        const rect = this.graphContainerRef.current.getBoundingClientRect();
        graphviz(this.graphContainerRef.current, {
            useWorker: false,
            width: rect.width,
            height: rect.height
        }).renderDot(graphString);
    };
    render() {
        return _jsx("div", { className: 'match_parent', ref: this.graphContainerRef });
    }
}
//# sourceMappingURL=Component_DependencyViewer.js.map